'use client';

import dynamic from 'next/dynamic';
import type { WorkspaceStudioRenderModel } from './contracts/server-model';
import { WorkspaceStudioSkeleton } from './shell/workspace-studio-skeleton';

type WorkspaceStudioClientBoundaryProps = {
  forceAuthSessionRead?: boolean;
  model: WorkspaceStudioRenderModel;
};

const WorkspaceStudioBlockClientRuntime =
  dynamic<WorkspaceStudioClientBoundaryProps>(
    () =>
      import('./shell/client').then(
        (module) => module.WorkspaceStudioBlockClient
      ),
    {
      loading: () => <WorkspaceStudioSkeleton />,
      ssr: false,
    }
  );

export function WorkspaceStudioClientBoundary({
  forceAuthSessionRead = false,
  model,
}: WorkspaceStudioClientBoundaryProps) {
  return (
    <WorkspaceStudioBlockClientRuntime
      forceAuthSessionRead={forceAuthSessionRead}
      model={model}
    />
  );
}
